import { render } from "./IconContainer.vue?vue&type=template&id=fccd544a"
import script from "./IconContainer.vue?vue&type=script&lang=js"
export * from "./IconContainer.vue?vue&type=script&lang=js"

import "./IconContainer.vue?vue&type=style&index=0&id=fccd544a&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__